export const BRAND_WIDTH = 150;
export const MODEL_WIDTH = 'auto';
export const TYPE_WIDTH = 120;
